module.exports = __webpack_public_path__ + "123475cea796c6ec67b2b3ac70050f5e.png";


//////////////////
// WEBPACK FOOTER
// ./Res/3rd/hdcon/img/top_logo.png
// module id = 1764
// module chunks = 1